export const ExclamationCircle = ({ width, height, fill = '#D1005D' }: React.SVGProps<SVGSVGElement>) => (
	<svg width={width} height={height} viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
		<circle cx="40" cy="40" r="38" stroke={fill} strokeWidth="4" />
		<path
			d="M43.6432 55.8005C43.643 53.7886 42.0088 52.1529 39.9983 52.1529C37.9878 52.1529 36.3516 53.7888 36.3516 55.8005C36.3516 57.8087 37.9878 59.4446 39.9983 59.4446C42.0088 59.4446 43.6432 57.8087 43.6432 55.8005Z"
			fill={fill}
		/>
		<path
			d="M39.9974 20.5557C37.9839 20.5557 36.3516 21.9639 36.3516 23.7011L36.3516 45.3616C36.3516 47.0988 37.9839 48.507 39.9974 48.507C42.0109 48.507 43.6432 47.0988 43.6432 45.3616L43.6432 23.7011C43.6432 21.9639 42.0109 20.5557 39.9974 20.5557Z"
			fill={fill}
		/>
	</svg>
);
